module.exports = __webpack_public_path__ + "svg/OpenSans-CondBold-webfont.f85a5e.svg";


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/core/client/assets/fonts/OpenSans-CondBold-webfont.svg
 ** module id = 324
 ** module chunks = 12
 **/